export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/empty.js
// module id = 398
// module chunks = 0 1 2 3 4